export class Login {
    constructor(
        public documento: string,
        public password: string
    ) { }
}
